import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import * as styles from './RecaptchaAttribution.module.scss';

// Required by Google wherever the reCAPTCHA badge is hidden (see global.scss).
const RecaptchaAttribution = ({ className }) => (
  <p className={cx(styles.recaptchaAttribution, className)}>
    This site is protected by reCAPTCHA and the Google{' '}
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </p>
);

RecaptchaAttribution.propTypes = {
  className: PropTypes.string,
};

RecaptchaAttribution.defaultProps = {
  className: null,
};

export default RecaptchaAttribution;
